// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-slides {
  width: 100%;
  padding: 40px;
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.6);
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 30px 80px rgba(67, 44, 21, 0.1);
  color: #1b1208;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
}

.onboarding-slides-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.onboarding-slides-eyebrow {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(27, 18, 8, 0.6);
}

.onboarding-slides-subtitle {
  margin-top: 6px;
  font-size: 0.95rem;
  color: rgba(27, 18, 8, 0.75);
}

.onboarding-slides-skip {
  border: 1px solid rgba(27, 18, 8, 0.12);
  background: transparent;
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 0.9rem;
  cursor: pointer;
}

.onboarding-slides-progress {
  margin-top: 0;
  display: flex;
  gap: 8px;
}

.onboarding-slides-dot {
  height: 8px;
  flex: 1 1;
  border-radius: 999px;
  background: rgba(49, 34, 24, 0.08);
}

.onboarding-slides-dot.is-active {
  background: linear-gradient(135deg, #fabd7c 0%, #f9a474 100%);
}

.onboarding-slides-dot.is-done {
  background: rgba(215, 152, 102, 0.55);
}

.onboarding-slides-slide {
  margin-top: 16px;
}

.onboarding-slides-title {
  margin: 0;
  font-size: 32px;
  font-weight: 400;
  color: #2a1d12;
  letter-spacing: -0.02em;
  line-height: 1.15;
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.onboarding-slides-error {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 68, 68, 0.12);
  color: #991b1b;
  font-size: 0.9rem;
}

.onboarding-slides-body {
  margin-top: 12px;
}

.onboarding-slides-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.onboarding-slides-choices {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.onboarding-slides-choice {
  width: 100%;
  padding: 16px 20px;
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
  border: 1px solid rgba(215, 152, 102, 0.25);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.5);
  color: rgba(46, 32, 22, 0.9);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}

.onboarding-slides-choice:hover {
  background: rgba(255, 255, 255, 0.8);
  border-color: rgba(215, 152, 102, 0.4);
  transform: translateY(-1px);
}

.onboarding-slides-choice.is-selected {
  background: linear-gradient(135deg, #fabd7c 0%, #f9a474 100%);
  border-color: transparent;
  color: #fff9f4;
  box-shadow: 0 8px 24px rgba(240, 167, 110, 0.3);
}

.onboarding-slides-input {
  width: 100%;
  font-size: 1rem;
  padding: 14px 16px;
  border: 1px solid rgba(215, 152, 102, 0.25);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.5);
  outline: none;
  color: rgba(46, 32, 22, 0.9);
}

.onboarding-slides-input:focus {
  border-color: rgba(215, 152, 102, 0.45);
  background: rgba(255, 255, 255, 0.8);
}

.onboarding-slides-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.onboarding-slides-btn {
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 500;
  border: 1px solid rgba(60, 48, 40, 0.12);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.onboarding-slides-btn.secondary {
  background: rgba(255, 255, 255, 0.5);
  color: rgba(60, 42, 30, 0.85);
}

.onboarding-slides-btn.primary {
  background: #fefefe;
  color: #3d3028;
  border: 1px solid rgba(60, 48, 40, 0.12);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.onboarding-slides-btn.primary:hover {
  background: #fff;
  border-color: rgba(60, 48, 40, 0.2);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.onboarding-slides-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.8);
  border-color: rgba(215, 152, 102, 0.4);
  transform: translateY(-1px);
}

.onboarding-slides-btn:disabled,
.onboarding-slides-skip:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 720px) {
  .onboarding-slides {
    padding: 24px;
  }

  .onboarding-slides-title {
    font-size: 26px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/OnboardingQuestionnaireSlides.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;EACnB,0CAA0C;EAC1C,6CAA6C;EAC7C,cAAc;EACd,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAO;EACP,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;EACf,uGAAuG;AACzG;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".onboarding-slides {\n  width: 100%;\n  padding: 40px;\n  backdrop-filter: blur(20px);\n  background: rgba(255, 255, 255, 0.6);\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-shadow: 0 30px 80px rgba(67, 44, 21, 0.1);\n  color: #1b1208;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n}\n\n.onboarding-slides-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.onboarding-slides-eyebrow {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: rgba(27, 18, 8, 0.6);\n}\n\n.onboarding-slides-subtitle {\n  margin-top: 6px;\n  font-size: 0.95rem;\n  color: rgba(27, 18, 8, 0.75);\n}\n\n.onboarding-slides-skip {\n  border: 1px solid rgba(27, 18, 8, 0.12);\n  background: transparent;\n  border-radius: 999px;\n  padding: 8px 12px;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.onboarding-slides-progress {\n  margin-top: 0;\n  display: flex;\n  gap: 8px;\n}\n\n.onboarding-slides-dot {\n  height: 8px;\n  flex: 1;\n  border-radius: 999px;\n  background: rgba(49, 34, 24, 0.08);\n}\n\n.onboarding-slides-dot.is-active {\n  background: linear-gradient(135deg, #fabd7c 0%, #f9a474 100%);\n}\n\n.onboarding-slides-dot.is-done {\n  background: rgba(215, 152, 102, 0.55);\n}\n\n.onboarding-slides-slide {\n  margin-top: 16px;\n}\n\n.onboarding-slides-title {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 400;\n  color: #2a1d12;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.onboarding-slides-error {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(255, 68, 68, 0.12);\n  color: #991b1b;\n  font-size: 0.9rem;\n}\n\n.onboarding-slides-body {\n  margin-top: 12px;\n}\n\n.onboarding-slides-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.onboarding-slides-choices {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.onboarding-slides-choice {\n  width: 100%;\n  padding: 16px 20px;\n  font-size: 1rem;\n  font-weight: 500;\n  text-align: left;\n  border: 1px solid rgba(215, 152, 102, 0.25);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.5);\n  color: rgba(46, 32, 22, 0.9);\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.onboarding-slides-choice:hover {\n  background: rgba(255, 255, 255, 0.8);\n  border-color: rgba(215, 152, 102, 0.4);\n  transform: translateY(-1px);\n}\n\n.onboarding-slides-choice.is-selected {\n  background: linear-gradient(135deg, #fabd7c 0%, #f9a474 100%);\n  border-color: transparent;\n  color: #fff9f4;\n  box-shadow: 0 8px 24px rgba(240, 167, 110, 0.3);\n}\n\n.onboarding-slides-input {\n  width: 100%;\n  font-size: 1rem;\n  padding: 14px 16px;\n  border: 1px solid rgba(215, 152, 102, 0.25);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.5);\n  outline: none;\n  color: rgba(46, 32, 22, 0.9);\n}\n\n.onboarding-slides-input:focus {\n  border-color: rgba(215, 152, 102, 0.45);\n  background: rgba(255, 255, 255, 0.8);\n}\n\n.onboarding-slides-actions {\n  margin-top: 16px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.onboarding-slides-btn {\n  padding: 10px 20px;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  border: 1px solid rgba(60, 48, 40, 0.12);\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.onboarding-slides-btn.secondary {\n  background: rgba(255, 255, 255, 0.5);\n  color: rgba(60, 42, 30, 0.85);\n}\n\n.onboarding-slides-btn.primary {\n  background: #fefefe;\n  color: #3d3028;\n  border: 1px solid rgba(60, 48, 40, 0.12);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.onboarding-slides-btn.primary:hover {\n  background: #fff;\n  border-color: rgba(60, 48, 40, 0.2);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n}\n\n.onboarding-slides-btn.secondary:hover {\n  background: rgba(255, 255, 255, 0.8);\n  border-color: rgba(215, 152, 102, 0.4);\n  transform: translateY(-1px);\n}\n\n.onboarding-slides-btn:disabled,\n.onboarding-slides-skip:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 720px) {\n  .onboarding-slides {\n    padding: 24px;\n  }\n\n  .onboarding-slides-title {\n    font-size: 26px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
